import { KeyboardEvent, useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_MST4010_R01 } from "./Content_MST4010_R01";
import { Info_MST4010_R01 } from "./Info_MST4010_R01";
import { useMST4010_R01Store } from "./Store_MST4010_R01";
import { Table_MST4010_R01 } from "./Table_MST4010_R01";
import { MST4010_R01Dto } from "./Dto_MST4010_R01";
import { AgGridReact } from "ag-grid-react";
import { SearchSection_MST4010_R01 } from "./SearchSection_MST4010_R01";

export const Container_MST4010_R01 = () => {

	const {
		setMST4010_R01List,
		selectedMST4010_R01, setSelectedMST4010_R01,
		editMST4010_R01, setEditMST4010_R01,
		allCount,
		initData,
	} = useMST4010_R01Store();
	
	const { setMessage } = useUiuxStore();
	

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: true,
		init: false
	});

	// 선택된 회사가 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: !selectedMST4010_R01,
			save: !selectedMST4010_R01 && !editMST4010_R01.compCd,
			print: !selectedMST4010_R01,
			excel: !selectedMST4010_R01
		}));
	}, [selectedMST4010_R01, editMST4010_R01]);

	const RESIZER = {
		code: 'MST4010_R01',
		type: 'height',
		storageKey: 'MST4010_R01-split-height',
		min: 5,
		max: 80,
		default: 47
	} as const;
	const gridRef = useRef<AgGridReact<MST4010_R01Dto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef,
	});


	const {
		handleExcelClick,
		handlePrintClick,
		fetchData,
		defaultMST4010_R01Row,
		initContainerData,
		handleCreateClick,
		handleSaveClick,
		handleDeleteClick,
	} = Content_MST4010_R01({  
		gridRef,
		setMessage,
	});

	


	return <div className="content-container">
    <Actionbar
		onFetchClick={fetchData}
		onCreateClick={handleCreateClick}
		onDeleteClick={handleDeleteClick}
		onSaveClick={handleSaveClick}
		onPrintClick={handlePrintClick}	
		onExcelClick={handleExcelClick}
		onInitClick={initContainerData}
    />
    <SearchSection_MST4010_R01 onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
			if (e.key === 'Enter') {
				fetchData()
			}
		}} />
    <div className="flex flex-1 flex-col px-[12px] gap-[4px] overflow-x-auto p-[10px]" ref={containerRef}>
		<div className="w-full" style={{ height: `${splitValue}%` }}>
        	<Info_MST4010_R01 data={selectedMST4010_R01} defaultMST4010_R01Row={defaultMST4010_R01Row()} />
		</div>
      {/* 리사이저 */}
		<div
        className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
        onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent) }
		// 드래그 시작 방지
		onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
		/>
		<div className="w-full " style={{ height: `${100 - splitValue}%` }}>
        	<Table_MST4010_R01 gridRef={gridRef} defaultMST4010_R01Row={defaultMST4010_R01Row()} />
		</div>
    </div>
    <Message />
	</div>
}